import { Link } from "react-router-dom";
import "../styles/AppCard.css";

type ProjectProps = {
  id: number;
  appName: string;
  appDescription: string;
  appImage: any;
};

function AppCard(props: ProjectProps) {
  return (
    <div
      className="appInfo"
      data-aos="zoom-in"
      data-aos-duration="500"
      data-aos-once="true"
    >
      <div className="appText">
        <div className="appTextBlock">
          <div className="appName">{props.appName}</div>
          <div className="appDesc">{props.appDescription}</div>
        </div>
        <Link className="appLink" to={`/projects/${props.id}`}>
          Learn More
        </Link>
      </div>
      <img src={props.appImage} alt={props.appName} className="appImage" />
      <Link className="appMobileLink" to={`/projects/${props.id}`}>
        Learn More
      </Link>
    </div>
  );
}

export default AppCard;
